import { createNoopInjectionToken } from 'ngxtension/create-injection-token';

export const [injectApiUrl, provideApiUrl, API_URL] =
  createNoopInjectionToken<string>('Api Url');

export const [injectCdnUrl, provideCdnUrl] =
  createNoopInjectionToken<string>('CDN Url');

export const [injectScanApiUrl, provideScanApiUrl] =
  createNoopInjectionToken<string>('Scan Api Url');

export const [injectStatusUrl, provideStatusUrl] =
  createNoopInjectionToken<string>('Status URL');

export const [injectIsTauri, provideIsTauri] =
  createNoopInjectionToken<boolean>('Check for desktop environment tauri');

export const [injectEnvironment, provideEnvironment] = createNoopInjectionToken<
  'development' | 'staging' | 'production'
>('APP Environment');
